export const getQualificadores = (state) => state.qualificadores.lista
export const getTotalQualificador = (state) => state.qualificadores.total
export const getIsCarregandoListaQualificador = (state) => state.qualificadores.isCarregandoLista
export const getQualificadorSelecionado = (state) => state.qualificadores.selecionado
export const getIsCarregandoQualificador = (state) => state.qualificadores.isCarregandoQualificador
export const getIsSavingQualificador = (state) => state.qualificadores.isSaving
